import {
  Popover,
  PopoverProps,
  styled,
  YStack,
  interaction,
  Adapt,
  Sheet,
} from '@mythical/ui'

import { Button, ButtonProps } from '../Button'
import { IconMore } from '../Icon'

const MenuContent = styled(YStack, {
  space: '$2',
  pt: '$3',
  $gtXs: {
    pt: '$0',
    space: '$1.5',
  },
})

export function Menu(props: PopoverProps) {
  return (
    <Popover allowFlip size="$2" {...props}>
      <Popover.Trigger
        tag="button"
        ai="center"
        gap="$1.5"
        cursor="pointer"
        {...interaction.opacity}
      >
        <IconMore color="$fgSecondary" />
      </Popover.Trigger>

      <Adapt when="xs">
        <Sheet
          animation="quick"
          modal
          dismissOnSnapToBottom
          snapPoints={[35, 30]}
        >
          <Sheet.Overlay
            bg="$backdrop"
            animation="quick"
            enterStyle={{ opacity: 0 }}
            exitStyle={{ opacity: 0 }}
          />
          <Sheet.Frame theme="bgSecondary" p="$3" pt="$1.5">
            <Sheet.Handle bg="$borderSecondary" />
            <Adapt.Contents />
          </Sheet.Frame>
        </Sheet>
      </Adapt>

      <Popover.Content
        theme="bgSecondaryOutlined"
        borderWidth={1}
        borderColor="$borderColor"
        elevate
        enterStyle={{ x: 0, y: -20, opacity: 0 }}
        exitStyle={{ x: 0, y: 10, opacity: 0 }}
        animation={[
          'quick',
          {
            opacity: {
              overshootClamping: true,
            },
          },
        ]}
      >
        <Popover.Arrow theme="bgSecondaryOutlined" borderWidth={4} />
        <MenuContent>{props.children}</MenuContent>
      </Popover.Content>
    </Popover>
  )
}

export function MenuItem(props: ButtonProps) {
  return (
    <Button
      {...props}
      theme="secondary"
      size="$4"
      br="$3"
      $gtXs={{ size: '$3' }}
    />
  )
}
